import { render } from "./CompanyCommonComponent.vue?vue&type=template&id=6066e70f&scoped=true&ts=true"
import script from "./CompanyCommonComponent.vue?vue&type=script&lang=ts"
export * from "./CompanyCommonComponent.vue?vue&type=script&lang=ts"

import "./CompanyCommonComponent.vue?vue&type=style&index=0&id=6066e70f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6066e70f"]])

export default __exports__